import React, { FunctionComponent, memo } from 'react';
import { useHistory } from 'react-router-dom';

import Close from '../../../UI/CloseButton';
import { sendEvent2 } from '../../../../utils/tracking';

const Overview: FunctionComponent = memo(() => {
  const history = useHistory();
  return (
    <div className="p24 pl90 bg-white mt2 pr30">
      <div className="flex justify-content-s">
        <div>
          <p className="fwb larger">Passbook</p>
        </div>
        <div>
          <Close
            handler={() => {
              sendEvent2(
                'close_btn',
                {
                  event_action: 'click',
                  event_category: 'top_nav',
                  screen_name: 'ft_passbook',
                  target_product: 'fastag',
                  event_platform: 'web',
                },
                true,
              );
              history.goBack();
            }}
          />
        </div>
      </div>
    </div>
  );
});

export default Overview;
